import {
  getArtifactHtmlDocumentTemplateId,
  htmlDocumentTemplateHasBody,
  type HtmlDocumentArtifactRef,
  type HtmlDocumentTemplateBodyRef
} from './html-document-artifact';

type DesignedDocumentRef = HtmlDocumentArtifactRef & {
  document?: {
    htmlDocumentTemplateId?: string | null;
    resolvedDesign?: {
      designId?: string | null;
      name: string;
      archived: boolean;
      hasPages: boolean;
    } | null;
  } | null;
};

export type DocumentDesign = {
  /** Linked to a Library Style, whose look the document keeps: it never takes a design. */
  styleLinked: boolean;
  /** Linked to a template with a body, whose page choices are frozen when marked final. */
  templateLinked: boolean;
  /** The design the version renders with. Both are null when it renders with none. */
  designId: string | null;
  designName: string | null;
  archived: boolean;
};

/** The design a document version renders with, as the server resolves it for the renderer. */
export const documentDesign = (
  artifact: DesignedDocumentRef,
  templates: (HtmlDocumentTemplateBodyRef & { id: string })[]
): DocumentDesign => {
  const templateId = getArtifactHtmlDocumentTemplateId(artifact);
  const template = templateId ? templates.find((each) => each.id === templateId) : undefined;
  const hasBody = !!template && htmlDocumentTemplateHasBody(template);
  const resolved = artifact.document?.resolvedDesign;
  return {
    // Built-in Styles have no template row, and a template this caller cannot see may be a
    // Style too, so anything but a template known to have a body counts as one.
    styleLinked: !!templateId && (templateId.startsWith('builtin:') || !hasBody),
    templateLinked: hasBody,
    designId: resolved?.designId ?? null,
    designName: resolved?.name ?? null,
    archived: !!resolved?.archived
  };
};
